export const useSSR = () => {
  const onSSR = (fn: () => void) => {
    onServerPrefetch(fn);
    if (typeof window !== 'undefined') {
      fn();
    }
  };

  return {
    onSSR,
  };
};
